module.exports = __webpack_public_path__ + "static/hxouselive-cc76bfddd665275d908b27e7791d9c45.jpg";